import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: '[appBackgroundImage]',
  standalone: true,
})
export class BackgroundImageDirective implements OnChanges, AfterViewInit {
  readonly el: HTMLElement;
  @Input() appBackgroundImage!: string;

  constructor() {
    const el = inject(ElementRef);

    this.el = el.nativeElement;
  }

  ngAfterViewInit(): void {
    if (this.appBackgroundImage) {
      this.setBackgroundImage(this.appBackgroundImage);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.setBackgroundImage(changes['appBackgroundImage']?.currentValue);
    } else {
      this.removeBackgroundImage();
    }
  }

  setBackgroundImage(url: string) {
    this.el.style.backgroundImage = `url(${url})`;
  }

  removeBackgroundImage() {
    this.el.style.backgroundImage = '';
  }
}
